import { render } from "./Admin.vue?vue&type=template&id=5deb99ba"
const script = {}
script.render = render

export default script